import React, { useEffect, useState } from 'react'
import { useLocation } from "react-router-dom";
import {useRazorpay} from "react-razorpay"
import { useNavigate, useParams } from 'react-router-dom'
export default function ConfirmPayment(){
  var [checkout, setCheckout] = useState({})
  var [user, setUser] = useState({})
  var {_id} =useParams()
  const {Razorpay} = useRazorpay()
  var navigate = useNavigate()
  async function getData(){
    let response = await fetch( "/api/booking", {
      method :"GET",
      headers:{
       "content-type":"application/json",
             }
})
response = await response.json()
if(response.result === "Done"){
 setCheckout(result)
  var result 
    if(_id === "-1")
      result = response.data[0]
    else 
     result = response.data.find((x)=>x._id ===_id)
     setCheckout(result)
     setUser(result?.user)
}

  }




 const initPayment = (data)=>{
  
  const options = {
    key :"rzp_live_L5EDF00D8FSjbH",
    amount: data.amount,
    currency: "INR",
    order_id :data._id,
    "prefill":{
      "name":user.name,
      "email":user.email,
      "contact":user.phone,

    },
    handler: async (res)=>{
      try {
        var item ={
          razorpay_payment_id :res.razorpay_payment_id,
          checkid :checkout._id
        }
        var res= await fetch ("/api/booking/verify",{
          method:"POST",
          headers:{
            "content-type":"application/json",
            "authorization":localStorage.getItem("token")
          },
          body:JSON.stringify(item)
        })
        res = await res.json()
        
        if(res.result === "Done")
          navigate("/confirmation")
      } catch (error) {
        
      }
    },
    theme:{
      color:"#3399cc"
    },
  }
  const rzp1 = new Razorpay(options);
  rzp1.open();
 }

 const paymentHandler = async()=>{
  try {
    var  res= await fetch("/api/booking/orders",{
      method:"POST",
      headers:{
        "content-type":"application/json",
        "authorization":localStorage.getItem("token")
      },
      body: JSON.stringify({amount:checkout.total})
    })
    res= await res.json()
    
    initPayment(res.data)
  } catch (error) {
    
  }
 }

useEffect(()=>{   
   getData()
},[_id])
    return (
    <>
     
    <div className="payment-container">
   
        <div className="payment-box">
        <h1>Make a Payment</h1>
        <p>Confirm your booking by paying securely via Razorpay.</p>
      {
             checkout?
        <button className="pay-button" onClick={paymentHandler} >Pay ₹{checkout.total}</button>
        :""
      }
      </div>
    </div>
    </>
  )
}